import { Avatar } from "@mantine/core";

const ChevronDownIcon = ({ size }: any) => {
  return (
    <Avatar
      style={{
        cursor: "pointer",
      }}
      size={size}
      src={"/assets/multiSelectChevronDown.png"}
    />
  );
};

export default ChevronDownIcon;
